import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { InputWrapper } from '@chegg-ui/input-wrapper';
import { normalizePhoneNumber } from '@chegg-ui/utils';
import { BasicStyledInput } from '../styles';
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var inputId = _ref.inputId,
      errorText = _ref.errorText,
      className = _ref.className,
      trailingIcon = _ref.trailingIcon,
      disabled = _ref.disabled,
      labelText = _ref.labelText,
      visuallyHideLabel = _ref.visuallyHideLabel,
      helperText = _ref.helperText,
      width = _ref.width,
      givenOnChange = _ref.onChange,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      adjustToBackgroundColor = _ref.adjustToBackgroundColor,
      dataTest = _ref['data-test'],
      remainingInputProps = _objectWithoutProperties(_ref, ["inputId", "errorText", "className", "trailingIcon", "disabled", "labelText", "visuallyHideLabel", "helperText", "width", "onChange", "type", "adjustToBackgroundColor", "data-test"]);

  return /*#__PURE__*/React.createElement(InputWrapper, {
    inputId: inputId,
    disabled: disabled,
    className: className,
    labelText: labelText,
    visuallyHideLabel: visuallyHideLabel,
    errorText: errorText,
    helperText: helperText,
    width: width,
    trailingIcon: trailingIcon,
    adjustToBackgroundColor: adjustToBackgroundColor,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(BasicStyledInput, _extends({}, remainingInputProps, {
    id: inputId,
    "data-test": dataTest || inputId,
    ref: ref,
    type: type,
    disabled: disabled,
    hasTrailingIcon: Boolean(trailingIcon) // TODO: this formatting is not very fully fleshed-out
    ,
    onChange: function onChange(e) {
      givenOnChange(type !== 'tel' ? e.target.value : normalizePhoneNumber(e.target.value));
    }
  })));
});
Input.displayName = 'Input';
export default Input;